export default class CacheContainer {
    constructor(_storageName) {
        this.storageName = _storageName;
        this.quickStorage = "{}";
        this.persistent = true;
        this.getKey = this.getKey.bind(this);
        this.getStorageKey = this.getStorageKey.bind(this);
        this.setKey = this.setKey.bind(this);
    }
    getStorageKey() {
        return `${this.storageName}_storage`;
    }
    getKey(_key) {
        let data = null;
        if (this.persistent) {
            console.log(`Looking in localStorage`);
            data = localStorage.getItem(this.getStorageKey());
        }
        else {
            console.log(`Looking in quickStorage`);
            data = `${this.quickStorage}`;
        }
        if (!data)
            return null;
        let parsedData = {};
        try {
            parsedData = JSON.parse(data);
        }
        catch (e) {
            return undefined;
        }
        let foundValue = parsedData[_key];
        if (foundValue)
            return foundValue;
    }
    setKey(_key, _content) {
        if (!_key)
            return false;
        let wroteData = {};
        let data = null;
        if (this.persistent)
            data = localStorage.getItem(this.getStorageKey());
        else
            data = `${this.quickStorage}`;
        if (data)
            wroteData = JSON.parse(data);
        wroteData[_key] = _content;
        if (this.persistent)
            localStorage.setItem(this.getStorageKey(), JSON.stringify(wroteData));
        else
            this.quickStorage = JSON.stringify(wroteData);
        return true;
    }
}
